const LoginPopupTypes = {
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgotpassword',
  NEW_PASSWORD: 'new-password',
  CONFIRM_REGISTRATION: 'confirm-registration',
}

export { LoginPopupTypes }
